module.exports = __webpack_public_path__ + "media/images/partner-7c277de0.png";